{% block sw_product_detail_seo_general %}
    {% parent %}

    <mt-card :title="$tc('hueb-seo.card.robots')" :isLoading="isLoading">
        <hueb-seo-robots :data="product">
        </hueb-seo-robots>
    </mt-card>

    <mt-card :title="$tc('hueb-seo.card.rich.labelRich')" :isLoading="isLoading">
        <hueb-seo-rich></hueb-seo-rich>
    </mt-card>

    <mt-card :title="$tc('hueb-seo.card.canonical.labelCanonical')" :isLoading="isLoading">
        <hueb-seo-canonical></hueb-seo-canonical>
    </mt-card>

{% endblock %}
